import React from 'react';
import type { EventNameNavProps } from '../components/EventNameNav';
import { EventNameNav } from '../components/EventNameNav';
import type { WebsiteHeaderLayout_NoPhoto } from '@shared/types/WebsiteHeaderSettings.types';

interface NoPhotoLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_NoPhoto;
  showPlaceholder?: boolean;
}

export const NoPhotoLayout = (props: NoPhotoLayoutProps) => {
  const { websiteHeader, showPlaceholder: _, ...restProps } = props;

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      headerTextData={websiteHeader.headerPhoto.eventName}
      {...restProps}
    />
  );
};
